<template>
  <div>
    <iframe
      src="https://192.168.120.6:8443/wicp/custcare/jsp/SubsCdrTreeView_Generic.jsp?cdrText=%7C3%2CE%2C0%2CC%2C20250312%20110130%2C20250312%20110130%2C20250312%20110130%2CIST%20%2B0530%2C%2C%2C%7C0%2C0%2C0%2C%2C%7C01025100026320030312163130%2C32003%2C3%2C%2C%2C%7CS%2C919845100026%2C287%2C1%2C1%2C919845100026%2C287%2C280%2C14%2C%2C%7C9005%2C01025100026320030312163130%2C1%2C6006%2C0%2C0%2C0%2C%2C%7C1%2C5%2C0%2C0%2C1%2C%7B919845100026%2C919845098226%2C7845%2C%2C919845098226%2C%2C%2C70%2C1%2C00%2C1%2C%2C3%2C3%2C0%2C%2C0%2C0%2C087858569198451000f0%2C%2C%2C919812345678%2C0%2C0%2C0%2C919812345678%2C000100000001000101010001%2C000000000000000001000000%2C0%2C3%2C%2C%2C%2C%7D%2C%2C%7C0%2C0%2C0%2C%2C%7C0%2C0%2C%2C%7C%3C10640%2C%2CS%2C919845100026%2C%2C%3E%7C%3C%2C%2C%2C%2C%2C%2C%2C%2C%2C%2C%2C%3E%7C%3C%2C%2C%2C%2C%2C%2C%2C%2C%2C%2C%3E%7C%3C%2C%2C%2C%2C%2C%2C%2C%2C%2C%2C%2C%2C%2C%3E%7C%3C%2C%2C%2C%2C%2C%2C%2C%2C%2C%2C%2C%2C%2C%3E%7CNULL%7CNULL&transId=01025100026320030312163130&genTime=2025%2F03%2F12%2016%3A31%3A30&serviceNum=919845100026&SubsDate=2024%2F09%2F24%2017%3A53%3A56&_=1743156992278"
      width="100%"
      height="650px"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: {
        transaction_id: "01346732339032116052600006",
        charge_party: "919926732339",
        calling_party: "-",
        usage: "10 MB",
        generation_time: "2025/03/21 16:05:56",
        result_code: "dummy*",
        called_party: "-",
        monetary_charge: "17000.000000 EUR",
        service_subs_type: "-1",
        type: "DATA",
      },
    };
  },
};
</script>
